module.exports = __webpack_public_path__ + "dacc60bc33cf921a84dd7c852b73abbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/31.jpg
// module id = 1359
// module chunks = 47